import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import '../pages/styling/about.scss'
import SerenPic from '../assets/about/seren-pic.jpg'
import Sonia from '../assets/about/sonia.jpg'
import Amanda from '../assets/about/amanda.jpg'
import Martyn from '../assets/about/martyn.jpg'
import Mira from '../assets/about/mira.png'
import Bob from '../assets/about/Bob.jpg'
import Jayne from '../assets/about/JayneS.jpg'
import Suki from '../assets/about/Suki.JPG'
import Joanne from '../assets/about/Joanne.png'
import Gemma from '../assets/about/Gemma.jpg'
import Melanie from '../assets/about/Melanie.jpg'
import Paws from '../assets/about/paws.png'
import facebookIcon from '../assets/contact/facebook.png'
import linkedInIcon from '../assets/contact/linkedin.png'
import instagramIcon from '../assets/contact/instagram.png'

export default function About() {
  return (
    <div className='container'>
      <Navbar />
      <div id='about'>
      <section className='aboutUs'>
        <h1 className='aboutUsTitle'>Serendipity Creative Writers</h1>
        <img src={SerenPic} alt='serendipity book cover' className='aboutSerenPic' />

        <h3 className='aboutUsSubtitle'>Who we are</h3>

        <div className='aboutUsContentContainer'>
          <span className='aboutTextTop'>
            Serendipity Creative Writers Group Charity (Reg. No. 1201197)
          </span>

          <div className='description-one'>
            <p>
              Serendipity was founded by Sonia Zoref as a result of years of struggling dealing with her own mental health journey and finally finding the cathartic and therapeutic outcomes of working through various mediums of the Arts, in particular, Creative Writing and Mindfulness.
            </p>
            <p>
              Serendipity Creative Writing and Mindful Workshops are held across Kirklees and the broader West Yorkshire area. They are two-hour workshops that are leader & service user led, are FREE and include free refreshments including CAKE. We operate an open-door policy and also receive referrals from the NHS and other Organisations.
            </p>
            <p>
              Our workshops are informal and fun. There is no experience of writing necessary and in fact, you don’t even have to write, you can doodle, watch, listen or talk. The emphasis being on building better stronger communities/friendships and participating in something special.
            </p>
            <p>
              The Facilitator provides generic writing exercises that usual last ten minutes, then we offer the opportunity for members to read their work if they so wish to. Quite often this results in small discussions. Its good to talk, good to share, and the only rule we have is that there are no rules. As long as we all respect each other, all positive feedback is welcomed.
            </p>
          </div>

          <div className='description-two highlight-banner'>
            We have been a founded organisation since 2018, reaching <span className='word-highlights'>charitable status</span> in December 2022.
          </div>

          <div className='description-three'>
            <p>
              Mental Health, like physical health is on a spectrum, and we work to reduce the stigma often attached. Everyone one of us, at some time or other suffer with our mental health; from severe mental health illness’ to poverty or loneliness. Serendipity is all about feel good. Everyone (16 years +) from all backgrounds and all experiences are welcome to join us. We also welcome immigrants and refugees. In fact, we embrace our differences and share our stories with one another in an informal yet educational environment that helps reduce misunderstanding, racism and hate crime.
            </p>
            <p>
              There is also an opportunity to learn new skills. Our workshops are relaxed and creative, we never put pressure on anyone regarding punctuation, spelling and grammar. We want everyone to feel relaxed and happy. Through the therapeutic art of creative writing, many of our members find the confidence to get back in to work or education, or even just getting back in to society.
            </p>
            <p>
              We published an Anthology ‘The Serendipity Handthology’ two years ago, and we are currently working on our next book, and there is opportunity for everyone to be involved.
            </p>
            <p>
              Serendipity work with school term times, but we hold Natter Groups during the school holiday (these are free sessions but a pay-for-your-own refreshments meeting).
            </p>
          </div>
                <div className='donations-card'>
        <div className='donations-header'>
          <span className='donations-badge'>Support Our Work</span>
          <h2 className='donations-title'>Make a Donation</h2>
          <p className='donations-intro'>
            If you would like to support our workshops and help us keep our community services free, you can donate directly to our charity bank account:
          </p>
        </div>

        <div className='donations-details-box'>
          <h3 className='account-name'>Serendipity Creative Writers</h3>
          <div className='account-numbers-grid'>
            <div className='detail-row'>
              <span className='detail-label'>Account No:</span>
              <strong className='detail-value'>53032191</strong>
            </div>
            <div className='detail-row'>
              <span className='detail-label'>Sort Code:</span>
              <strong className='detail-value'>20-98-98</strong>
            </div>
          </div>
        </div>
      </div>
          <div className='description-four callout-banner'>
            All our workshops are in local Community Café’s because we know that it is important for people to feel <span className='word-highlights'>safe and welcome</span> in normalised settings.
          </div>
        </div>
      </section>
      <section className='ourStaff'>
        <h1 className='staffTitle'>Our Staff & Trustees</h1>
        <div className="staffImages">

          {/* Sonia */}
          <div className='imgItem'>
            <img src={Sonia} alt='Sonia' className="staffImage" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Sonia Zoref</h2>
              <h2 className='staffJob'>Project Manager/Founder</h2>
              <p className='staffDescription'>
                Sonia has an English Literature with Creative Writing Degree that she gained as a mature student,
                holding down a part time job and raising 3 children. Sonia has facilitated creative writing workshops with Serendipity for almost 5 years.
                Prior to that she delivered community creative writing workshops within educational settings; schools and colleges.
                Sonia has training in counselling and has worked with mental health organisations as a freelance writer.
                Sonia was commissioned to publish a collection of her poems relating to mental health and was the feature poet in the University of Huddersfield’s anthology. Sonia embraces all Art forms.
                She is currently working on her 2nd poetry collection and also working on a novel.
              </p>
            </div>
          </div>

          {/* Amanda */}
          <div className='imgItem'>
            <img src={Amanda} alt='Amanda' className="staffImage" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Amanda Rhodes</h2>
              <h2 className='staffJob'>Secretary/Trustee</h2>
              <p className='staffDescription'>
                Amanda has been a Care Support Worker for the Mid Yorkshire Care Trust,
                a charitable organisation. This involves complex work such as administration of medication including buckle Midazolam and suction,
                working with babies to the elderly.
                Her work also includes giving respite to unpaid carers in order for them to be able to take a break.
                She has 3 grown up children and 6 grandchildren which keep her very busy. She also enjoys gardening and social family occasions.
              </p>
            </div>
          </div>

          {/* Jayne */}
          <div className='imgItem'>
            <img src={Jayne} alt='JayneS' className="staffImage" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Jayne Shepherd</h2>
              <h2 className='staffJob'>Treasurer/Trustee</h2>
              <p className='staffDescription'>
                Jayne has a higher Masters degree in pure Maths and has a wealth of experience in statistics and accounting;
                working in hotel Management and 'Virgin' accounts management. She has successfully owned and run Restaurants,
                Bars, Pubs and an award-winning Fish and Chip Shop in Pickering; was Area Manager for Cooplands and is
                currently General Manager for Aramark Defence Services in York where she lives. Jayne has two grown up children and has one grandson.
                Jayne loves travelling; UK and abroad, going on long country walks with her two gorgeous dogs.
              </p>
            </div>
          </div>

          {/* Mira */}
          <div className='imgItem'>
            <img src={Mira} alt='Mira' className="staffImage" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Mira Fadel</h2>
              <h2 className='staffJob'>Chairperson/Trustee</h2>
              <p className='staffDescription'>
                Mira is an ambitious and well-educated British woman who was born in Baghdad,
                and brought up in the very cosmopolitan city Dubai.
                She received her higher education in the UK and has worked as an IT specialist for over two decades.
                Mira is a Publisher, Freelance Teacher, Translator and Community Café owner. Her spare time is spent reading,
                translation and developing computer applications.
              </p>
            </div>
          </div>

          {/* Martyn */}
          <div className='imgItem'>
            <img src={Martyn} alt='Martyn' className="staffImage" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Martyn Haymonds</h2>
              <h2 className='staffJob'>Volunteer</h2>
              <p className='staffDescription'>
                Martyn is a proud volunteer with Serendipity. Martyn joined Serendipity a few years ago as a service
                user and it changed his life so much that he wanted to be more hands-on and now is actively
                engaged in all areas from facilitating workshops to giving talks to corporations and
                organisations about the work we do, and the difference we make.
                Martyn’s background history in social work brings much to our organisation, but more than that he
                brings much of himself that is caring and compassionate, supporting and nurturing to our group
                members, and in return is supported and nurtured too.
              </p>
            </div>
          </div>

          {/* Bob */}
          <div className='imgItem'>
            <img src={Bob} alt='Bob' className="staffImage focus-bob" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Bob Cartwright</h2>
              <h2 className='staffJob'>Volunteer</h2>
              <p className='staffDescription'>
                Bob has lived in and around Batley, Birstall and Dewsbury most of his life, having studied at Batley Grammar School
                and later at Askham Bryan College as a horticultural student. He has a rich diverse work background,
                from factory work as a printers knocker-up to working with the Manpower Services Scheme
                (a UK Government Agency), where he was responsible for the delivery of training and career support for the unemployed.
                He enjoys the outdoors; walking and camping and helps as a member of the Scouts,
                though due to a leg injury in recent years he isn’t as active as he would like,
                and now focuses more on arranging training courses and events. Bob has been a valued member of Serendipity for six years
                and a volunteer for over two years.
                His love of poetry and writing is evident, and quite often he is able to lead workshops by using his own inspiring work as writing exercises.
              </p>
            </div>
          </div>

          {/* Gemma */}
          <div className='imgItem'>
            <img src={Gemma} alt='Gemma' className="staffImage align-top" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Gemma Lea Blagbrough</h2>
              <h2 className='staffJob'>Trustee</h2>
              <p className='staffDescription'>
                Gemma has a Bachelor’s Degree in youth and Community Studies and a PGCE
                in Life Long Learning from the University of Huddersfield. Previously CEO
                and founder of Jigsaw Enterprise and Director at Carers Trust Mid Yorkshire where
                she worked with children and their families to make training a fun and
                interactive learning experience.
                In 2013 she was winner of the Forward Women in Business in the ‘start up business woman of the year’.
                Despite having MS, she regularly fund-raises for various Charities, including Serendipity by taking part in fundraiser events
                including triathlons. Gemma has been a regular member of Serendipity for five years;
                she is an inspirational woman and bringing lots of energy and fun
                to our workshops and is a great asset to our management team.
              </p>
            </div>
          </div>

          {/* Joanne */}
          <div className='imgItem'>
            <img src={Joanne} alt='Joanne' className="staffImage" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Joanne Campbell</h2>
              <h2 className='staffJob'>Trustee</h2>
              <p className='staffDescription'>
                Jo Qualified as an Occupational Therapist I 1992 and worked in NHS Mental Health services for 20 years in
                both inpatient services and community settings facilitating group work and individual therapy for people with acute and severe mental health conditions. She retrained as a Psychotherapist while working in the NHS and set up her private practice in 2012 offering both long and short term therapy (profile can be found on the Counselling Directory).
                She is a registered member of the British Association for Counsellors
                and Psychotherapists. In 2013 she began doing some counselling for Kirklees Mind
                (which later became New Mind Counselling Services) where she later became their Counselling Co-ordinator
                and a Trustee (this closed in 2023 due to lack of funding). Jo is committed to promoting positive outcomes for
                people with mental health challenges (all of us). She has been a regular member
                of Serendipity since 2023 and says she has experienced first hand the amazing work we do,
                and wants to support us going forward as a Trustee.
              </p>
            </div>
          </div>

          {/* Melanie */}
          <div className='imgItem'>
            <img src={Melanie} alt='Melanie' className="staffImage" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Melanie Green</h2>
              <h2 className='staffJob'>Volunteer</h2>
              <p className='staffDescription'>
                Mel is an Aspie, an Artist (with a BA Degree in Fine Art), and a Poet.
                She has a wealth of training in the Arts & Mental Health (Health & Social Care level 2).
                Mel worked as a Volunteer with MENCAP as a Support Worker for 3 years.
                She has been an integral part of Serendipity for several years and brings lots to our workshops in way of enthusiasm and inspiration.
                Mel is keen to facilitate Art and Art & Crafts workshops in the new Serendipity Arts Hub
                because she firmly believes that ART IS THERAPY.
              </p>
            </div>
          </div>

          {/* Suki */}
          <div className='imgItem'>
            <img src={Suki} alt='Suki' className="staffImage" />
            <div className='imgItemSection'>
              <h2 className='staffName'>Suki</h2>
              <h2 className='staffJob'>Emotional Support Canine & Mascot</h2>
              <p className='staffDescription'>
                Suki joined the Serendipity Family last year & is a registered emotional support dog.
                She needed to be around people dealing with the loss of her best friend Tia.
                Being petted and loved has helped her enormously, and as it turns out, helps others feel better too.
                Tia was born in Romania in 2023 and rescued by the amazing organisation Waggs and Wet noses,
                who fostered and nurtured her until she found her forever home with Sonia and Fat Elvis (the Maine Coon cat).
                Suki is a gentle soul. She loves unconditionally and brings so much joy to so many people.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="socialLinks">
        <a href="https://www.facebook.com/serendipitycreativewriters.charity/" rel="noreferrer" target="blank"><img src={facebookIcon} alt="facebook" className="link" /></a>
        <a href="/" rel="noreferrer" target="blank"><img src={linkedInIcon} alt="linkedIn" className="link" /></a>
        <a href="/" rel="noreferrer" target="blank"><img src={instagramIcon} alt="instagram" className="link" /></a>
      </section>
      <div className='link-wags-container'>
        <div className='link-wags-section'>
          Click here to check out&nbsp;
          <a href="https://www.facebook.com/groups/2008820529405469/" rel="noreferrer" target="blank" className='link-wags'>
          Wags N' Wet Noses Dog Rescue&nbsp; <img src={Paws} alt='paws' className="paws" /></a>
        </div>
        <div className='link-wags-section'>
          Click here to check out&nbsp;
          <a href="https://www.westyorkshiredogrescue.co.uk" rel="noreferrer" target="blank" className='link-wydr'>
          West Yorkshire dog rescue&nbsp; <img src={Paws} alt='paws' className="paws" /></a>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  )
}
